import {
  min,
  maxLength,
  optional,
  required,
  bool,
  isDate,
  notInPast,
  isNotBefore,
  afterToday,
  float,
} from "modules/validation";

const notBeforeDateFrom = isNotBefore("date_from");

const maxDelegatesValidator = (value, allValues) => {
  const maxDelegates = allValues.maximum_number_of_delegates;
  if (
    maxDelegates !== undefined &&
    maxDelegates !== null &&
    Number(value) > Number(maxDelegates)
  ) {
    return "Number of delegates cannot be greater than maximum number of delegates";
  }
  return undefined;
};

const bedroomsRequiredValidator = (value, allValues) => {
  if (allValues.bedrooms_required) {
    if (!Array.isArray(value) || value.length === 0) {
      return "You must specify at least one bedroom.";
    }
  }
  return undefined;
};

const stage1 = {
  event_name: [required(), maxLength(256)],
  accommodation_only: bool,
  number_of_delegates: [required(min(1))],
  min_number_of_delegates: [min(1), maxDelegatesValidator],
  maximum_number_of_delegates: optional(min(1)),
  date_from_required: [required(), isDate],
  date_to_required: [required(), isDate, notBeforeDateFrom],
  date_from_future: [required(), isDate, notInPast, afterToday],
  date_to_future: [required(), isDate, notInPast, notBeforeDateFrom],
  room_style_id: required(),
  date_flexible: bool,
  date_flexible_notes: [],
};

const briefPreferences = {
  location: optional(maxLength(255)),
  event_type: optional(maxLength(255)),
  budget: [optional(float, min(0), maxLength(9))],
};

const stage2 = {
  bedrooms_required: bool,
  bedroom_dates: [bedroomsRequiredValidator],
  bedroom_additional_notes: [],
  quantity: min(0),
};

const stage3 = {
  event_timings: required(),
  syndicate_room_notes: [],
  exhibition_space_notes: [],
  private_dining_notes: [],
  back_projection_notes: [],
  any_equipment_notes: [],
  date_decision_date: [required(), isDate],
  is_edge_enquiry: bool,
  is_trinity_enquiry: bool,
};

const additionalDataCapture = {
  client_name: optional(maxLength(255)),
  company_id: required(),
  client_id: required(),
  share_with_venues: bool,
  suppress_notifications: bool,
  branch_id: required(),
  estimated_value: [required(), float, min(0)],
  estimated_commission: [required(), float, min(0)],
};

const corporateDataCapture = {
  booking_desk_id: optional(maxLength(255)),
  meeting_host_id: required(),
  department_id: required(),
  booking_desk_user_id: optional(maxLength(255)),
  branch_id: required(),
};

const canSubmit = ({
  event_name,
  number_of_delegates,
  date_from,
  date_to,
  date_flexible,
}) => {
  if (!event_name) {
    return false;
  }

  if (!number_of_delegates || !/^[0-9]+$/.test(number_of_delegates)) {
    return false;
  }

  if (!date_from || !date_to || typeof date_flexible !== "number") {
    return false;
  }

  return true;
};

export {
  canSubmit,
  stage1,
  briefPreferences,
  stage2,
  stage3,
  additionalDataCapture,
  corporateDataCapture,
};
